import React from "react";
import { ConversionResponse } from "../../../types/conversionTypes";

interface ConversionResultProps {
  result: ConversionResponse | null;
}

export const ConversionResult: React.FC<ConversionResultProps> = ({
  result,
}) => {
  if (!result) return null;

  // パスからファイル名を取得する関数
  const getFileName = (path: string): string => {
    return path.split(/[\/\\]/).pop() || path;
  };

  return (
    <div
      className={`mt-8 p-6 rounded-lg shadow-md transition-all duration-300 transform 
                ${
                  result.success
                    ? "bg-green-50 border border-green-200 hover:shadow-lg"
                    : "bg-red-50 border border-red-200 hover:shadow-lg"
                }`}
    >
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          {result.success ? (
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
              <svg
                className="h-6 w-6 text-green-600"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
          ) : (
            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
              <svg
                className="h-6 w-6 text-red-600"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </div>
          )}
        </div>
        <div className="flex-1">
          <h3
            className={`text-lg font-medium ${
              result.success ? "text-green-800" : "text-red-800"
            }`}
          >
            {result.message}
          </h3>
          {result.success && result.convertedFilePath && (
            <div className="mt-2 text-sm text-green-700 bg-green-50 p-3 rounded-md">
              <div className="font-medium">出力ファイル：</div>
              <div className="mt-1 font-mono break-all">
                {getFileName(result.convertedFilePath)}
              </div>
            </div>
          )}
          {!result.success && result.errorDetails && (
            <div className="mt-2 text-sm text-red-700 bg-red-50 p-3 rounded-md">
              <div className="font-medium">エラー詳細：</div>
              <div className="mt-1">{result.errorDetails}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
